'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@repo/ui';
import { getWarningsColorClass, getWarningsIcon } from '@/helpers/warnings';
import { VaultV2WarningLevel } from '@/types/enums';
import type { Warning } from './WarningHoverCard/WarningHoverCardContent';
import { WarningHoverCard } from './WarningHoverCard';
export interface WarningIconProps {
  warnings: Warning[];
  iconSize?: number;
  isSimple?: boolean;
}
const WarningIcon = t0 => {
  const $ = _c(15);
  const {
    warnings,
    iconSize: t1,
    isSimple: t2
  } = t0;
  const iconSize = t1 === undefined ? 20 : t1;
  const isSimple = t2 === undefined ? false : t2;
  let activeWarnings;
  let colorClass;
  let t3;
  let t4;
  if ($[0] !== warnings) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      activeWarnings = warnings.filter(_temp);
      if (activeWarnings.length === 0) {
        t4 = null;
        break bb0;
      }
      colorClass = getWarningsColorClass(activeWarnings);
      t3 = getWarningsIcon(activeWarnings);
    }
    $[0] = warnings;
    $[1] = activeWarnings;
    $[2] = colorClass;
    $[3] = t3;
    $[4] = t4;
  } else {
    activeWarnings = $[1];
    colorClass = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  const worstIcon = t3;
  let t5;
  if ($[5] !== iconSize) {
    t5 = {
      width: iconSize,
      height: iconSize
    };
    $[5] = iconSize;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== colorClass || $[8] !== t5 || $[9] !== worstIcon) {
    t6 = <Icon icon={worstIcon} className={colorClass} style={t5} />;
    $[7] = colorClass;
    $[8] = t5;
    $[9] = worstIcon;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== activeWarnings || $[12] !== isSimple || $[13] !== t6) {
    t7 = <div className="gap-xs flex items-center"><WarningHoverCard warnings={activeWarnings} isSimple={isSimple}>{t6}</WarningHoverCard></div>;
    $[11] = activeWarnings;
    $[12] = isSimple;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default WarningIcon;
function _temp(t0) {
  const {
    level
  } = t0;
  return level !== VaultV2WarningLevel.Green;
}